import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getResourceItem = async (
  projectId,
  resourceId,
  activeEmployerInfo
) => {
  const apiPath = `workflow/project/${projectId}/resource/${resourceId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
